<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  provide() {
    return {
      reload: this.reload,
    };
  },
  created: function () {
    // this.$router.replace("/login");
  },
  mounted() {
    // this.$router.afterEach((to, from, next) => {});
  },
};
</script>

<style lang="less">


/* @import url("https://cache.amap.com/lbs/static/main1119.css"); */
@import "../node_modules/font-awesome/css/font-awesome.min.css";
@import "../node_modules/flex.css/dist/flex.css";
body,
html {
  font-family: Microsoft YaHei, PingFang SC, Helvetica Neue, Helvetica,
    Hiragino Sans GB, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}
ol,ul {
  list-style: none;
  padding-inline-start: 0;
}
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 6px;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #c6c6c6; /*滚动条的背景颜色*/
}

.maxCascaderWidth .el-cascader-menu:last-of-type{
    width: 270px;
}

.maxCascaderWidth .el-cascader-menu:nth-of-type(1),.maxCascaderWidth .el-cascader-menu:nth-of-type(2),.maxCascaderWidth .el-cascader-menu:nth-of-type(3){
  width: 180px;
}
#edui153_toolbarbox {
  width: 100% !important;
}
.v-modal {
  z-index: 888 !important;
}

.el-table__body {
  width: 100%;
  table-layout: fixed !important;
}
.registrationRecord .el-drawer__body {
  padding: 20px;
  border-top: 1px solid #e5e5e5;
}
.registrationRecord .el-drawer__header > :first-child {
  font-size: 18px;
  font-weight: 700;
  color: #2a2a2a;
}
.registrationRecord .dataDescription {
  margin-bottom: 20px;
}
.el-dialog__header {
  padding: 20px 40px !important;
  border-bottom: 1px solid #eee;
}
.el-dialog {
  border-radius: 0.5em !important;
}
.el-dialog__body {
  padding: 20px 30px 30px 30px !important;
}
/* 弹窗头部字体 */
.el-dialog__title {
  font-size: 16px !important;
  color: #2a2a2a !important;
}
.uploadtop .el-dialog {
  margin-top: 1vh !important;
}
.el-dialog__wrapper {
  /* z-index: 999 !important; */
}
.dialog .el-dialog--center .el-dialog__body {
  padding: 0 !important;
}
.IdenticalPadding .el-dialog__body{
  padding: 30px 40px 0 40px!important;
}
.el-dialog.activityDiaStyle {
  max-height: calc(100% - 96px);
  max-width: calc(100% - 210px);
  height: calc(100% - 96px);
  width: calc(100% - 210px);
  overflow-y: auto;
  position: fixed;
  top: 96px;
  left: 210px;
  margin: 0;
}
.el-drawer__open :focus,
.registrationRecord /deep/ :focus {
  outline: 0;
}
// 去掉input[type=number]默认上下箭头样式
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
textarea::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: #f5f5f5; 
font-family: Arial;
} 
textarea:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: #f5f5f5; 
font-family: Arial;
} 
textarea::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: #f5f5f5; 
font-family: Arial;
} 
textarea:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: #f5f5f5 ; 
font-family: Arial;
}
.el-textarea__inner{
  border: 1px solid #eee !important;
  font-family: Arial;
}
.findform {
  display: flex;
  height: 50px;
  margin-top: 10px;
  padding-left: 20px;
}
/*去掉打开抽屉时自动选中标题时的蓝色边框*/
.el-drawer__header span:focus {
  outline: 0;
}
// 富文本
.el-autocomplete{
  width: 90%;
}
// 富文本高度增加
.w-e-text-container{
  height: 700px !important;
}
.stepTitle{
  font-weight: 700;
  font-size: 16px;
  color:#333;
  margin-top: 30px;
  margin-left: -65px;
}
.toExamineTitle {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  i {
    font-size: 80px;
    color: #f8bb86;
  }
  p {
    font-size: 18px;
    color: #333;
  }
}
// tab标签
.el-tabs__item {
  font-size: 15px !important;
  font-weight: bold !important;
}
.el-tabs__item:hover {
  color: #F56C6C !important;
  cursor: pointer;
}
.el-tabs__item.is-active {
  color: #F56C6C !important;
}
.el-tabs__active-bar {
  background-color: #F56C6C !important;
}
// 截图
.cropper-content {
  .cropper {
    width: auto;
    height: 50vh;
    text-align:center;
  }
}
.eleWidthInput .el-form-item__content{
  width: auto;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.addressfind:focus{
  background: #F56C6C;
  color: #fff;
  border: 1px solid #F56C6C;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}

.uploadImg .el-upload-list{
  display: inline;
}
/* 店铺视频 */
.hiddenInput {
  position: relative;
  float: left;
  /* display: inline-block; */
  background: #F56C6C;
  color: #fff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
  line-height: 32px;
  cursor: pointer;
  margin-right: 10px;
}
.hiddenInput input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
// 红色提示文案
.redTips {
  width: 100%;
  font-size: 13px;
  color: #F56C6C;
}
.uploadActiveForm{
  .uploadActive{
    display: inline-block;
    margin-top: 2px;
    .bannerImgUrl{
      display: inline-block;
    }
  }
}
// 1200*675
.activeUploadImg{
  .avatar-uploader-icon{
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px!important;
    border: 1px solid #eee;
    text-align: center;
  }
}
// 1:1
.proportionImg {
  .avatar-uploader-icon{
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px!important;
    border: 1px solid #eee;
    text-align: center;
  }
}
//  修改操作列线条问题
.el-table__fixed-right::before, .el-table__fixed::before {
  height: 0 !important;
}
.edui-editor-toolbarbox {
  width: 100% !important;
  position: inherit !important;
}
.imgUrl {
  width: 80px;
  margin-right: 10px;
  cursor: pointer;
}
.edui-default {
  width: 95%;
}
.edui-default .edui-editor {
  z-index: 0 !important;
}
/* 微信扫码支付 */
.wxsmzfClass {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}
.wxsmzfClass p {
  font-size: 26px;
  font-weight: bold;
}
.wxsmzfClass img {
  width: 200px;
}
/* 温馨提示 */
.reminder{
  margin: 0 0 10px 5px;
  font-size: 14px;
}
.redClass {
  color: #F56C6C;
}

//表头
thead th:not(.is-hidden):last-child {
  border-left: 1px solid #EBEEF5;
}
//表单
.el-table__row {
  cursor: pointer;
  td:not(.is-hidden):last-child {
    border-left: 1px solid #e4e7ec;
  }
}

.sweetAlert {
  color: #F56C6C !important;
}
.sa-button-container .confirm {
  background: #F56C6C !important;
}
.sa-button-container .cancel {
  border: 1px solid #F56C6C !important;
  color: #F56C6C !important;
  background: #fff !important;
}
/* .confirm{
  background:#F56C6C !important
} */
/* .cancel{
  border:1px solid #F56C6C !important;
  color:#F56C6C !important;
  background: #fff !important;
} */
#tzr {
  display: inline-block !important;
  width: 80%;
}
#sc {
  display: inline-block !important;
  width: 80%;
}
/* 查询按钮 */

/* 时间选择 至 */
.till {
  text-align: center;
  margin: 0 18px !important;
}

.el-upload--picture-card {
  border: 1px solid #eee !important;
}
.add_new_btn {
  position: relative;
  margin-right: 32px;
  width: 78px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  float: right;
  margin-bottom: 0;
  margin-top: 10px;
  float: right;
}
.model_top_title {
  display: inline-block;
  height: 50px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 50px;
  white-space: nowrap;
  /* border-bottom: 1px solid #F56C6C; */
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
  width: auto;
}
.model_top_title:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1px;
  width: 100%;
  background: #F56C6C;
}
.search_btn {
  background: #F56C6C !important;
  color: #fff !important;
  border: 1px solid #F56C6C !important;
  width: 78px !important;
}
.el-button {
  padding: 11px 20px;
}
.cancle.el-button, .cancle.el-button:focus,
.cancle.el-button:hover {
  border-color: #F56C6C !important;
  background-color: #fff;
  color: #F56C6C;
}
.search_btn.el-button:focus,
.search_btn.el-button:hover {
  border-color: #eee !important;
  background-color: #F56C6C;
  color: #fff;
}
.normal_btn {
  width: 85px;
  height: 38px;
}
.model_section {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.view_container {
  margin-right: 25px;
  padding-bottom: 30px;
}
.clearfix:after {
  content: " ";
  display: block;
  line-height: 0;
  height: 0;
  visibility: hidden;
  clear: both;
}
.viewContainer{
  margin-left: 10px;
}
/* #lispage .el-pagination .btn-prev{
  margin-right:32px !important
} */
.el-pager li {
  width: auto !important;
}
.el-form .el-form-item__label {
  width: 80px;
}
// 店铺基本信息
.shopTitle {
  width: 90%;
  font-size: 17px;
  margin-left: 20px;
}
.el-table td, .el-table th{
  height: 46px !important;
  padding: 0 !important;
}
.el-table th.is-leaf {
  background: rgba(187, 187, 187, 0.47) !important;
  color: #1e1e1e !important;
  // padding: 16px 0;
}
.el-table td {
  border-bottom: 1px solid #EBEEF5;
  bottom: 1px;
}
.table_container {
  height: auto;
  margin: 0 10px;
}
// 阴影
.main_container {
  margin-top: 10px;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  overflow: hidden;
}
.banner {
  margin-right: 50px;
  padding: 0 15px;
  margin-top: 10px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  top: 150px;
  height: auto;
  padding-bottom: 10px;
  width: 100%;
}
.letter .el-form-item__label{
  letter-spacing: 2.3px;
}
.letter1 .el-form-item__label{
  letter-spacing: 2px;
}
.porino .el-input__inner {
  cursor: pointer;
}
.letter .el-form-item__label{
  letter-spacing: 2.3px;
}
.letter1 .el-form-item__label{
  letter-spacing: 2px;
}
.el-cascader__tags .el-tag>span {
  flex: auto;
}
.el-cascader-node__postfix {
  top: 50%;
  transform: translateY(-50%);
}
.letter .el-form-item__label{
  letter-spacing: 2.3px;
}
.letter1 .el-form-item__label{
  letter-spacing: 2px;
}
.findneirong12 .el-form-item__content{
  width: 100%
}
.formwidth .el-form-item__content{
  width: 100% !important
}
.klanjia .el-form-item {
  margin-bottom: 0px;
}
.normal_width {
  width: 221px !important;
}
.whyclose .el-form-item__error {
  margin-left: 2px;
  margin-top: 2px;
}
.goods_red {
  display: block;
  background: #F56C6C;
  width: 60px;
  height: 2px;
  margin-left: 13px;
  position: relative;
  /* top: 20px; */
}
.sortable-ghost {
  opacity: 0.4;
  background-color: #f4e2c9;
}
.el-range-input{
  cursor: pointer;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color:#C0C4CC;
}
.select1 .el-form-item__content{
  width: 100%
}
.sub_chaxun1 .el-form-item__content{
  width:65%
}
.optionscity .el-form-item__content{
  width: 100%
}
.key .el-form-item__content{
  width:47%
}
.key .el-input{
  width:112% !important
}
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
/* 表格 */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}
/* 操作 */
.handles p {
  font-size: 12px;
}
.handles i {
  font-size: 18px;
  margin-top: 5px;
}
/* 删除提示 */
.delete_tips {
  margin-top: 28px;
  text-align: center;
  font-size: 16px;
  color: #333;
}
.add_bill_delete .delete_footer {
  height: 40px;
  text-align: center;
  margin: 80px auto 40px;
  /* padding-left: 88px; */
  line-height: 40px;
}

.add_bill_delete .delete_footer p {
  margin: 0 auto;
  display: inline-block;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
}

.add_bill_delete .delete_footer p:last-child {
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
  margin-left: 10px;
}
/* 大图预览-蒙层 */
.fullscreenMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */
  /* display: flex; */
  align-items: center;
  justify-content: center;
  z-index: 3;
}
.el-upload-list {
  display: none;
}
.el-form-item__content {
  width: 99%;
}
.el-select {
  width: 100%;
}
.divReset {
  width: 25px;
  height: 25px;
  margin-right: 20px;
  float: right;
  cursor: pointer;
}
.divReset>img {
  width: 100%;
}
.sanjiao {
  width: 0;
  height: 0;
  overflow: hidden;
  border-width: 10px;
  border-color: transparent transparent #000 transparent;
  border-style: dotted dotted solid dotted;
  transform: rotate(45deg);
  position: absolute;
  right: -10px;
  top: -10px;
  margin-left: -10px;
}
.el-form-item__label {
  color: #404040;
}
.banner_list {
  display: flex;
  /* display: -webkit-flex; */
  align-items: center;
  overflow: hidden;
  justify-content: center;
  overflow: hidden;
  width: 100px;
  height: 43px;
  margin: 0 auto;
}
.el-loading-spinner{
  font-size: 30px;
}
.el-loading-text{
  font-size: 23px !important;
}
.avatar {
  display: block;
}
.back {
  background-color: #F56C6C !important;
  color: #fff !important;
}
.table_inner_container {
  overflow-x: auto;
  height: auto;
}
.order_toolbar_footer,
.toolbar_footer {
  text-align: right;
  padding-bottom: 10px;
}
.tittleDiv {
  padding-top: 1px;
}
.inner_input_group {
  width: auto !important;
}
.tab_col_set {
  color: #303030;
}
/* 列表样式 */
.spanList {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  padding: 0 5px;
}
// 列表操作按钮样式
.handle {
  color: #6786b4 !important;
  cursor: pointer;
}
.ashSpan {
  color: #ccc;
}
.whiteDis.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
/* 表格 */
/* 操作 */
/* .handle p {
  width: 40% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}
.notice_content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  width: 100%;
}
.edui-editor-toolbarboxouter .edui-default {
  line-height: 0;
}
/* 表格 */
/* 操作 */
/* .handle p {
  width: 40% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}
#edui153_toolbarbox {
  position: static !important;
  top: 0;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}
/* 富文本 操作栏 */
.edui-editor-toolbarbox .edui-default {
  z-index: 1000;
}
#edui153 {
  width: 95%;
  /* edui-editor */
}
.letter .el-form-item__label {
  letter-spacing: 1px !important;
}
.data100 .el-date-editor {
  width: 100%;
  background: #f5f7fa !important;
}
.width100 .el-form-item__content {
  width: 100%;
}
.width100 .el-select {
  width: 100%;
}
.more100 .el-form-item__content {
  display: flex;
}
.changstyle .el-icon-plus:before {
  margin-left: 10px;
}
.disinput fieldset {
  display: none;
}
.checks .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #F56C6C !important;
  border-color: #F56C6C !important;
}

.elformbottom .el-rate {
  line-height: 3;
}
.elformbottom .el-textarea__inner {
  min-height: 90px !important;
}
.elformbottom .el-form-item__content {
  width: 80%;
  margin-left: 0px !important;
}
.elformbottom .el-form-item {
  margin-bottom: 10px !important;
}
.elform123 .el-select {
  width: 100%;
}
.swal-class {
  margin-bottom: 0px !important;
}
.el-form-item__label {
  white-space: nowrap;
}
.lablepadding .el-form-item__label {
  padding: 0px;
}
.lablepadding .el-form-item__content {
  width: 100%;
}
/* ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  } */

/* ::-webkit-scrollbar-thumb {
background-color: #a1a3a9;
border-radius: 4px;
} */
/* 上传图片 */
.el-upload--picture-card {
  margin-top:5px;
  width: 80px;
  height: 80px;
  border: 1px solid #d2d2d2;
  position: relative;
}

/* 上传后图片大小 */
.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
/* 上传后图片 查看删除功能 */
.el-upload-list--picture-card .el-upload-list__item-actions {
  width: 80px;
  height: 80px;
}
.table_pic .el-upload--picture-card {
  width: 34px;
  height: 34px;
  overflow: hidden;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
/* 产品优势 图片label 售后政策 在售店面 */
.advantage_pic .el-form-item__label,
.goods_shop .el-form-item__label,
.goods_policy .el-form-item__label {
  width: 80px !important;
}
.goods .el-form-item__label {
  font-size: 12px;
}
.tr_title th {
  font-weight: normal;
}
.el-input .el-input__count .el-input__count-inner {
  line-height: 36px;
}

.ban_tab {
  float: left;
}
.ban_tab ul {
  display: block;
  text-align: center;
  height: 0;
  line-height: 0;
}
.item {
  display: flex;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  border-bottom: 1px solid #eee;
  color: #888;
}
.table_color_box {
  border: 1px solid #eee;
  float: left;
  width: 530px;
}
.table_color_box .item:last-child {
  border: none;
}
.table_color_box .color {
  padding: 10px 0;
  text-align: center;
  width: 200px;
}
.table_color_box .img_vox {
  width: 55px;
  padding: 10px 15px;
  text-align: center;
}
.table_color_box .action_del {
  text-align: center;
  width: 90px;
  padding: 10px 0;
  width: 255px;
  cursor: pointer;
}
.shop_content .table_color_box {
  width: auto;
}
.shop_content .table_color_box .color {
  width: 340px;
}
.shop_content .table_color_box .img_vox {
  width: 340px;
}
.shop_content .table_color_box .action_del {
  width: 120px;
}
// 可视化视频
.videoClass {
  width: 80px;
  height: auto;
  display: flex;
  flex: 1;
  position: relative;
}
/* 预览视频 */
.previewingVideo {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  // display: inline-block;
}
.previewingVideo>img {
  width: 80px;
  height: 80px;
}
/* 使用半透明黑色作为蒙层颜色 */
.iconcontainer{
  position: absolute;
  top: 2px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
/* 第一帧播放icon */
.playIcon {
  width: 30px;
  position: absolute;
  top: 25px;
  left: 25px;
}
.chahao {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  color: #666;
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
  z-index: 999;
}
.chahao img {
  width: 100%;
  height: 100%;
  display: block;
}
.el-image-viewer__img{
  max-height: 60% !important; /* 调整高度比例 */
}
/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  color: #fff !important;
  cursor: default;
  border-color: #F56C6C;
  background-color: #F56C6C;
}
.dur_title {
  color: #888;
}

/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
    color: #040404;
    font-size: 12px;
}

/* 分页 */
.el-pager li {
    margin: 0 10px;
    width: 31px;
    height: 29px;
    background-color: #ffffff;
    border: solid 1px #eeeeee;
}

.el-pager li.active {
    border-color: #F56C6C;
    background-color: #F56C6C;
}

.el-pagination .btn-prev,
.el-pagination .btn-next {
    border: 1px solid #eeeeee;
    background: #fff;
    margin: 0 10px;
}
.el-tree-node__children .el-tree-node__content {
  padding-left: 30px;
}

.cell {
  color: #040404;
  font-size: 12px;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}
.left_node {
  width: 25%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #555;
}
.right_node {
  float: right;

  display: flex;
  flex-wrap: wrap;
  width: 65%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #555;
  border-left: 1px solid #eee;
  min-height: 48px;
}
.formdata3 .el-input__inner {
  cursor: pointer;
}
.cell {
  color: #040404;
  font-size: 12px;
}
.el-pager li.active {
  color: #fff !important;
  cursor: default;
  border-color: #F56C6C;
  background-color: #F56C6C;
}

/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}

/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}

/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  color: #fff !important;
  cursor: default;
  border-color: #F56C6C;
  background-color: #F56C6C;
}
.dur_title {
  color: #888;
}
.normal_dialog .el-dialog__header {
  text-align: left;
}
.normal_dialog .cancle_btn:hover {
  background: #fff;
}
.is-checked .el-checkbox__label {
  color: #606266;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.overflow .el-checkbox__label {
  width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.wenben {
  display: flex;
  margin-top:20px;
}
.el-popper {
  z-index: 5050 !important;
}

/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}
/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}

/* 表格 */
/* 操作 */
/* .handle p {
  width: 50% !important;
  cursor: pointer;
  color: #b2b2b2;
} */
.cell {
  color: #040404;
  font-size: 12px;
}

/* 分页 */
/* .el-pager li{
  margin:0 5px;
} */
.el-pager li.active {
  border-color: #F56C6C;
  background-color: #F56C6C;
}
.cell {
  color: #040404;
  font-size: 12px;
}
.dur_title {
  color: #888;
}
.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
  position: absolute;
  right: 0;
  width: 324px;
  left: 50% !important;
  top: 36px;
}
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
.quill-editor {
  max-width: 1230px !important;
  margin-right: 10px;
}
.ql-editor {
  height: 400px !important;
}
textarea.el-textarea__inner {
  resize: none;
}
.tree_data {
  border-top: 1px solid #eeeeee;
}
.tree_data .el-tree-node__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  cursor: pointer;
  position: relative;
  border: 1px solid #eeeeee;
}
.tree_data .el-tree-node__content {
  padding-left: 15px !important;
}
.tree_data .el-tree-node__children .el-tree-node__content {
  padding-left: 52px !important;
}
.tree_data
  .el-tree-node__content
  .el-tree-node__content
  .el-tree-node__content {
  padding-left: 56px !important;
}
.tree_data .el-tree-node .el-tree-node__content {
  border-top: none;
}
.tree_data .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #555;
}
.tree_data .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #333;
  border-color: rgb(150, 144, 144);
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #F56C6C !important;
  border-color: #F56C6C !important;
}
.tree_data .el-tree-node__expand-icon {
  color: #000;
}
.tree_data .el-checkbox {
  color: #333;
}
.tree_data .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #fff;
  border-color: #999;
}
.tree_data .el-tree-node__expand-icon.is-leaf{
  padding-left: 30px !important;
}
.lineheighttree .el-tree-node__content {
  height: auto !important;
  line-height: 48px;
}
// 选择创客tree
.cktree .el-tree-node__content {
  height: auto !important;
  line-height: 30px;
}
.el-form-item__content .line.el-col-2 {
  margin-left: 19px !important;
}
.el-menu-item.is-active,
.el-menu-item:hover {
  background: #fff !important;
  color: #555;
  position: relative;
}
.el-submenu:hover {
  background-color: #333333 !important;
}
.el-submenu__title:focus,
.el-submenu__title:hover,
.el-submenu:hover .submenu__title {
  background-color: #333333 !important;
  color: #555 !important;
}
.el-menu-item.is-active:after,
.el-menu-item:hover:after {
  content: "";
  top: 50%;
  left: 0;
  height: 20px;
  position: absolute;
  width: 3px;
  background: #F56C6C;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.el-table .cell i {
  font-size: 20px;
  position: relative;
  top: 2px;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #eee !important;
}
.el-input__suffix-inner .el-icon-arrow-up:before {
  content: "\e78f";
  font-size: 18px;
  position: relative;
  top: 0;
}

thead th {
  font-weight: 400;
  color: #000 !important;
}
.tree_data .el-checkbox__inner {
  width: 16px;
  height: 16px;
}
.tree_data .el-checkbox__inner:hover,
.tree_data .el-checkbox__input.is-focus .el-checkbox__inner {
  border: 1px solid #dcdfe6;
}
.tree_data .el-checkbox__inner:after {
  box-sizing: content-box;
  content: "";
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 6px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}
.tree_data .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #F56C6C;
}
/* 优惠券 */

.el-checkbox__inner {
  width: 18px;
  height: 18px;
}
.el-checkbox__inner:after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #F56C6C;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 5px;
  position: absolute;
  top: 3px;
  transform: rotate(45deg) scaleY(0);
  width: 6px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #F56C6C;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fff;
  border-color: #eee;
}
.el-drawer__body {
  overflow: scroll;
  border-top: 1px solid #e5e5e5;
}
.el-drawer__header {
  margin-bottom: 15px;
}
.el-pager li {
  border-radius: 3px;
}
.fail {
  color: #F56C6C !important;
}
.ac_btn_fail {
  color: #b2b2b2 !important;
  cursor: pointer;
}
.ac_btn_normal {
  color: #009944 !important;
  cursor: pointer;
}
.is-left {
  text-align: left;
  padding-left: 15px;
}
.el-upload__tip {
  color: #888 !important;
}
.el-switch__label * {
  font-size: 12px !important;
}

.search_container {
  position: relative;
}
.search_result {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  z-index: 15;
  background: #fff;
  border: 1px solid #d2d2d2;
}
.search_result li {
  margin-left: 0;
  height: 40px;
  padding-left: 20px;
  cursor: pointer;
}
.search_result li:hover {
  background-color: #eee;
}
.el-pagination button,
.el-pager li {
  min-width: 30px !important;
  margin: 0 5px !important;
}
.el-pagination .btn-prev {
  padding-right: 6px !important;
}
.el-pagination .btn-next {
  padding-left: 6px !important;
}
.el-pager li.active + li {
  border-left: solid 1px #eeeeee !important;
}
.select .el-input__inner {
  border: 1px solid #eee !important;
}
.time_picker_icon {
  display: none;
}
ul {
  margin: 0;
}
.action_container {
  text-align: center;
  display: block;
}
.action_container p {
  margin: 0 6px !important;
  float: none !important;
  display: inline-block !important;
  width: auto !important;
}
.toolbar .el-form--inline .el-form-item:last-child {
  margin-right: 0;
}
.spaceil_table .el-table__body-wrapper td {
  padding: 4px 0 !important;
}
.ban_tab ul {
  display: block;
  text-align: center !important;
  height: 28px !important;
  line-height: 28px !important;
}
.ban_tab li {
  display: inline-block !important;
  float: none !important;
  margin-left: 0 !important;
  margin: 0 10px;
}
/* 固定底部操作按钮 */
.gudingdibu{
  width: 90%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #eee;
  position: fixed;
  left: 210px;
  bottom: 0;
  z-index: 2;
}
body .el-table th.gutter {
  display: table-cell !important;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-out 0.2s;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.cell p {
  cursor: pointer;
}

body {
  /*background-color: #324057;*/
  margin: 0px;
  padding: 0px;
  /*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
  background: #1f2d3d;

  /*font-weight: 400;*/
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  background: #fff;
}

.el-submenu [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar .el-form-item {
  margin-bottom: 10px;
}

.toolbar {
  background: #fff;
  padding: 10px 10px 0px 0px;
  /* margin-left: 25px; */
  /* margin-top: 20px; */
}
.el-breadcrumb__inner img {
  position: relative;
  top: -2px;
  margin-right: 8px;
}
.toolbar .el-form--inline .el-form-item {
  margin-right: 20px;
}
.el-switch .el-switch__label {
  color: #6786b4;
}
.el-submenu,
.el-menu-item {
  border-bottom: 1px solid #444;
}

.el-menu .el-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding-left: 60px !important;
  border: none;
}
/* .selewidth .el-input-group__append{
    padding: 0px 5px;
}
.selewidth .el-input__inner{
  padding: 0 9px
} */
.changjing .el-textarea__inner {
  min-height: 164px !important;
}
.changjing .el-form-item__content{
  width: 100%
}
.dormwidth .el-form-item__content {
  width: 83% !important;
}
.is-active {
  color: #F56C6C !important;
}
.el-cascader-menu {
  width: 217px;
}
/* 新增页面 */
.add_invoice_edit .el-col-24 {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
  margin: 0 0 20px 0;
}

.add_invoice_edit .el-col-24 p {
  width: 120px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
// tab间距
.el-tabs__header{
  margin: 10px 0 0 0 !important;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
}
.goodslist1 {
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  font-weight: 700;
  color: #2a2a2a;
  border-bottom: 1px solid #eee;
  /* padding-bottom: 20px; */
}
.fuji {
  position: relative;
  /* padding-top: 5px; */
  cursor: pointer;
}
// tab标签隐藏下划线
.el-tabs--card>.el-tabs__header .el-tabs__item{
  border-bottom: none !important;
}
/* 选择框 */
.add_invoice_edit .whether p i {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 10px;
}

.add_invoice_edit .whether p img {
  width: 100%;
  height: 100%;
}

.edit_footer {
  margin-top: 50px;
  margin-left: 75px;
}

.edit_footer p {
  float: left;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
  margin-right: 10px;
}

.edit_footer p:last-child {
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
}
.pro .el-input__inner{
  cursor: pointer;
}
.filters_Name1 .el-form-item__content{
    width:53%
}
.filters_Name2 .el-form-item__content{
    width:43%
}
.filters_Name3 .el-form-item__content{
    width:76%
}
li {
  list-style: none;
}
i {
  font-style: normal;
}
img {
  vertical-align: middle;
  display: inline-block;
}
/* 按钮 */
.add_banner .dialog-footer {
  margin-left: 100px;
}
.add_banner .dialog-footer p {
  float: left;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
  margin-right: 10px;
}
.add_banner .dialog-footer p:last-child {
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
}
/* 表单 */
/* .el-form{
  margin-left:15px
} */
/* 弹窗框 */
.el-pagination {
  padding: 2px 0px !important;
}
.el-pagination .btn-next {
  margin-right: 0px !important;
}

/* 主题 */
.content_title {
  text-align: left;
  margin-left: 20px !important;
}
/* 时间图标 */
.toolbar .line {
  margin-left: 10px;
  line-height: 40px;
}
.el-select-dropdown__item.selected {
  color: #F56C6C !important;
  font-weight: normal !important;
}

.banner_list {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  overflow: hidden;
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
.action_icon_shenhe {
  position: relative;
  top: -2px;
}
.normal_width {
  width: 150px !important;
}
.sub_chaxun {
  margin-right: 40px !important;
}
.el-textarea textarea{
  padding-bottom: 13px;
}
.el-textarea .el-input__count{
  height: 12px;
  line-height: 12px;
}
</style>


// WEBPACK FOOTER //
// App.vue?4a45c71f